import React from "react";
import LabelIcon from "@mui/icons-material/Label";
import Breadcrumbs from "../components/Breadcrums";
import { FinePrintDetails } from "../configs";

const breadcrumbItems = [
  { label: "Home", path: "/" },
  { label: "Fine Print", path: "/fine-print" },
];

function FinePrint() {
  return (
    <div className="flex flex-col justify-center lg:p-3">
      <Breadcrumbs items={breadcrumbItems} />
      {/* <h1 className="hidden lg:block text-2xl font-bold text-primary-main my-5">
        Fine Print
      </h1> */}
      <div className="flex flex-wrap flex-col gap-1 mb-3">
        {FinePrintDetails.map((item, index) => (
          <div
            key={index}
            className="flex flex-auto min-w-100 flex-col p-5 bg-secondary-medium rounded-lg 
            border-primary-main hover:shadow-xl hover:bg-opacity-70"
          >
            <h2 className="text-lg font-bold text-primary-main">
              {item.title}
            </h2>
            <p className="flex flex-col text-sm text-primary-main mt-2 gap-3">
              {item.description.length > 1 ? (
                item.description.map((desc, index) => (
                  <div
                    key={index}
                    className="flex flex-row gap-3 items-start lg:items-center"
                  >
                    <LabelIcon />
                    {desc}
                  </div>
                ))
              ) : (
                <span>{item.description}</span>
              )}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FinePrint;
